const overrideLinkMenu = theme => ({
    MuiLink: {
        defaultProps: {
            underline: 'hover'
        }
    }
})

export default overrideLinkMenu